import React from 'react'
import { Button } from 'react-bootstrap'
import { ReactComponent as EditImg } from '../../../../images/Edit_Outline.svg'

export default function ButtonSummit({
  fnCancle = () => {},
  isRead,
  setIsRead,
  isSave,
  handleSubmit,
  textPimary = (
    <>
      <EditImg style={{ width: '14px' }} className="me-2" />
      Edit
    </>
  )
}) {
  return (
    <div>
      {isRead ? (
        <Button
          size="sm"
          type="button"
          className="px-4"
          style={{
            backgroundColor: '#1A2B45',
            border: '1px solid #1A2B45',
            height: '35px'

            // width: '110px'
          }}
          onClick={() => setIsRead(!isRead)}
        >
          <span className="menu-active">{textPimary}</span>
        </Button>
      ) : (
        <span className="d-flex ">
          <Button
            className="me-2 px-4"
            size="sm"
            disabled={isSave}
            style={{
              backgroundColor: '#2C5DFE',
              border: '1px solid #2C5DFE',
              // width: '110px',
              height: '35px'
            }}
            onClick={handleSubmit}
          >
            <span className="menu-active">
              {' '}
              {isSave ? 'กำลังบันทึก...' : 'บันทึก'}
            </span>
          </Button>

          <Button
            size="sm"
            type="button"
            className="px-4"
            style={{
              backgroundColor: '#efefef',
              border: '1px solid #efefef',
              color: '#1A2B45',
              // width: '110px',
              height: '35px'
            }}
            onClick={() => {
              setIsRead(!isRead)
              fnCancle()
            }}
          >
            <span className="menu-active">ยกเลิก</span>
          </Button>
        </span>
      )}
    </div>
  )
}
